// import Cart from './components/Cart/Cart';
// import Layout from './components/Layout/Layout';
// import Products from './components/Shop/Products';

import { useSelector } from "react-redux";

import Search from "./components/Search/Search";
import Quote from "./components/Quote/Quote";
import GuestInfo from "./components/GuestInfo/GuestInfo";
import SendEmail from "./components/SendEmail/SendMail";
import ReturningGuestPopup from "./components/Popups/ReturningGuestPopup";
import ProgramPopup from "./components/Popups/ProgramPopup";
import AccommodationPopup from "./components/Popups/AccommodationPopup";

import BottomBanner from "./components/BottomBanner/BottomBanner";
import WhatsApp from "./components/WhatsApp/WhatsApp.js";
import LogSearch from "./components/LogSearch/LogSearch.js";
import URLPrefill from "./components/URLPrefill/URLPrefill.js";
import ReturningWelcomeWatcher from "./components/Popups/ReturningWelcomeWatcher.js";

function App() {
  //const showCart = useSelector((state) => state.ui.cartIsVisible)

  const datesConfirmed = useSelector((state) => state.booking.datesConfirmed);
  const quoteAccepted = useSelector((state) => state.quote.quoteAccepted);
  const sumbitForm = useSelector((state) => state.form.sumbitForm);

  //console.log(datesConfirmed)

  return (
    <div>
      <URLPrefill clearQuery={true} />
      <AccommodationPopup />
      <ReturningGuestPopup />
      <ProgramPopup />
      {!datesConfirmed && <Search />}
      {datesConfirmed && !quoteAccepted && <Quote />}
      {datesConfirmed && quoteAccepted && !sumbitForm && <GuestInfo />}
      {datesConfirmed && quoteAccepted && sumbitForm ? (
        <SendEmail />
      ) : (
        <BottomBanner />
      )}   
      <WhatsApp /> 
      <ReturningWelcomeWatcher />    
      <LogSearch />
    </div>
  );

  // return (
  //   <Layout>

  //     {showCart && <Cart />}
  //     <Products />
  //   </Layout>
  // );
}

export default App;
